module.exports = __webpack_public_path__ + "static/media/reefer.19ddfce5.svg";